import { DateFormat, formatDate } from "common";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { Event, OPEN_UNLIMITED, Permission, Timeslot } from "types";
import { IsGranted } from "../../Common/IsGranted";
import { QuantitySpinner } from "../../Common/QuantitySpinner/QuantitySpinner";
import { api } from "@/api/api";
import { useInvalidate } from "@/hooks/useInvalidation";
import { callDebounced } from "@/utils/debounceUtils";

interface capacitySpinnerProps {
    event?: Event;
    timeslot: Timeslot;
}

export const CapacitySpinner = ({ event, timeslot }: capacitySpinnerProps) => {
    const invalidate = useInvalidate();
    const [capacity, setCapacity] = useState(event?.max ?? timeslot.capacity.max);

    const { mutate: updateEventCapacity, isLoading: isUpdating } = useMutation(async () => {
        if (event) {
            await api.put(`/events/${event.id}`, { max: capacity });
        } else {
            await api.post("/events", {
                experience: { id: timeslot.product },
                quantity: { reserved: timeslot.capacity?.reserved ?? 0 },
                start: formatDate(timeslot.arrivalDatetime, DateFormat.DATE_TIME_UTC_ISO),
                max: capacity === OPEN_UNLIMITED ? null : capacity,
            });
        }

        invalidate("events", event?.id);
        invalidate("timeslots");
    });

    return (
        <IsGranted permissions={Permission.MODIFY_EQUIPMENT_CAPACITY}>
            <QuantitySpinner
                size="large"
                isLoading={isUpdating}
                value={capacity}
                text="Capacity"
                classNames={{ label: "text-white" }}
                onChange={(value: number) => {
                    setCapacity(value);
                    callDebounced(500, updateEventCapacity, value);
                }}
            />
        </IsGranted>
    );
};
